module.exports = __webpack_public_path__ + "img/user-logo.e1306a39.jpg";